import React, { useEffect, useState } from 'react'
import { CreditCard } from 'lucide-react';

import Logo from '../assets/logo.png'
import Controller from '../assets/gameController.png'
import BlueBar from '../assets/BlueBar.png'
import RedCar from '../assets/RedCar.png'
import BlueTruck from '../assets/BlueTruck.png'

export default function Home() {

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({ duration: 500 });
    }
  }, []);

  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [resetPhone, setResetPhone] = useState('');
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingReset, setLoadingReset] = useState(false);
  const [message, setMessage] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [country, setCountry] = useState('');


  function Login(e) {
    e.preventDefault();
    setLoadingLogin(true);
    fetch(`https://apiv2.mobileartsme.com/login?phonenumber=${phone}&password=${password}&serviceid=1656&type=signin&country=lb`)
      .then(resp => resp.json())
      .then(response => {
        if (response.Error === 0) {
          if (response.Result.Status === 0) {
            response.Result.Phone = phone;
            localStorage.setItem('GF_User_Data', JSON.stringify(response.Result));
            window.location.href = '/dashboard/home';
          } else {
            setMessage(response.Result.Description);
          }
        } else {
          setMessage(response.Result);
        }
      })
      .catch(() => setMessage('Login failed.'))
      .finally(() => setLoadingLogin(false));
  }

  function ResetPassword(e) {
    e.preventDefault();
    setLoadingReset(true);
    fetch(`https://apiv2.mobileartsme.com/gfort_ForgetPassword?phonenumber=${resetPhone}&apisource=1&language=LB`)
      .then(resp => resp.json())
      .then(response => {
        setResetMessage(response.result)
        setLoadingReset(false);
      })
  }

useEffect(()=>{
 fetch('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry')
 .then(resp => resp.text())
 .then(country => {
  setCountry(country)
 })
},[])

  return (
    <div  >

      <div className='container d-flex flex-row align-items-center justify-content-between mt-3' >
        <img src={Logo} />
        <a className='btn btn-primary' href='#loginsection' >Login</a>
      </div>


      <section className='hero container mt-4' style={{ height: '80vh', display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
        <div className='row' >
          <div className='col-lg-6' >
            <div className='d-flex flex-column justify-content-center align-items-start gap-3' style={{ height: '100%' }} >
              <h1>A GREAT VARIETY OF HTML5 <br></br> GAMES AWAITS YOU!</h1>
              <p >Games Fort offers a wide selection of fun, impressive and casual games with a broad appeal to every age group and gender</p>
              <a className='btn btn-primary' href={`https://publisherads.click/?SMCampaign=6e7f7678-c74c-447d-b53f-6b8ad7ed2f77&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=${country}&themeid=3&portal=GamesFort`}> <CreditCard /> Subscribe</a>
            </div>
          </div>

          <div className='col-lg-6' >
            <img src={Controller} width={'100%'} />
          </div>
        </div>
      </section>


      <section className='container'  >
        <img src={BlueBar} width={'100%'} style={{marginTop:'10rerm' , marginBottom:'10rem'}} />

      </section>



      <section className='container my-5' >

        <div className='row my-5' >
          <div className='col-lg-6' >
            <img src={RedCar} width={'100%'} style={{ borderRadius: '15px' }} />
          </div>
          <div className='col-lg-6' >
            <div className='d-flex flex-column justify-content-center my-3' style={{ height: '100%' }} >
              <h3>FREE VERSION</h3>
              <ul>
                <li>Enjoy entertaining games</li>
              </ul>
            </div>
          </div>
        </div>


        <div className='row my-5'>
          {/* Text: should appear 2nd on mobile, 1st on desktop */}
          <div className='col-lg-6 order-2 order-lg-1'>
            <div className='d-flex flex-column justify-content-center my-3' style={{ height: '100%' }}>
              <h3>PREMIUM USERS</h3>
              <ul>
                <li>Get premium and unlimited games</li>
                <li>Add games to your favourites list</li>
                <li>Rate Games</li>
              </ul>
            </div>
          </div>

          {/* Image: should appear 1st on mobile, 2nd on desktop */}
          <div className='col-lg-6 order-1 order-lg-2'>
            <img src={BlueTruck} width='100%' style={{ borderRadius: '15px' }} />
          </div>
        </div>


      </section>


      <section id='loginsection' className='container mb-5' style={{ marginTop: '10rem' }}>
        <h2>Login and Begin Your Game Now</h2>

        <form className='mt-3' style={{ maxWidth: '500px' }} onSubmit={Login}>
          <input
            className='form-control'
            placeholder='Phone Number'
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          <div className='d-flex flex-row align-items-center mt-2 gap-2'>
            <input
              className='form-control'
              type='password'
              placeholder='Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button className='btn btn-primary' type='submit' disabled={loadingLogin}>
              {loadingLogin ? <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div> : 'Login'}
            </button>
          </div>

          {message && <p className='text-danger mt-2'>{message}</p>}
        </form>

        <p className='my-3'>
          <button className='btn text-light p-0' data-bs-toggle='modal' data-bs-target='#resetPasswordModal'>
            Forgot Password?
          </button>
        </p>


        <div
          className='modal fade'
          id='resetPasswordModal'
          tabIndex='-1'
          aria-labelledby='resetPasswordModalLabel'
          aria-hidden='true'
        >
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header' style={{ border: 'none' }}>
                <h5 className='modal-title' id='resetPasswordModalLabel'>Reset Password</h5>
                <button type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
              </div>

              <div className='modal-body'>
                <p>Enter your phone number to reset you password</p>
                <form onSubmit={ResetPassword}>
                  <div className='mb-3'>
                    <input
                      className='form-control'
                      placeholder='Enter Phonenumber'
                      value={resetPhone}
                      onChange={(e) => setResetPhone(e.target.value)}
                      required
                    />
                  </div>
                  {resetMessage && <p className='text-success mt-2'>{resetMessage}</p>}

                  <div className='d-flex justify-content-end'>
                    <button className='btn btn-primary' type='submit' disabled={loadingReset}>
                      {loadingReset ? 'Sending...' : 'Reset'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>


      </section>
    </div >
  )
}
